/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @description 地区服务类接口
 */
import getRegionList from "./getRegionList";

export class RegionApi {
  constructor(
    public getRegionList: (
      success?: ({
        data,
        ext,
        state,
        errors,
      }: {
        data: Array<dictionary.RegionDto>;
        ext: ObjectMap;
        state: "SUCCESS" | "FAIL" | "EXCEPTION";
        errors?: Array<string>;
      }) => any,
      fail?: (error: string) => any
    ) => void
  ) {}
}

export default {
  getRegionList,
} as RegionApi;
